module.exports = __webpack_public_path__ + "static/media/Punch.b0ec6f88.wav";